import { createContext } from 'react';

import { RequiredCategoricalBarChartConfiguration } from '../types/categorical-bar-chart.js';
import { defaultConfig } from '../types/defaults.js';

export const CategoricalBarChartBaseConfigContext =
  createContext<
    Pick<
      RequiredCategoricalBarChartConfiguration,
      | 'colorPalette'
      | 'valueRepresentation'
      | 'groupMode'
      | 'layout'
      | 'colorPaletteMode'
      | 'toolbar'
    >
  >(defaultConfig);
